module.exports = __webpack_public_path__ + "static/04-82fd06408f3b00d46e6e7bfbef801ccb.jpg";